import { FC, useEffect, useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';
import { $LibraEnablePixelTracking, $LibraEnableSmartBanner } from '~/utils/libra/seo-smart-banner';
import { generateOneLink } from '~/utils/active';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { $RootTraffic } from '@lemon8/web-app-shared/atom';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

interface ISmartBannerPixelProps {
  schemaOption: DeepLinkBuildingProps;
  enterPageId: string;
  enterPageType: string;
}

export const SmartBannerMeta: FC = () => {
  const enable = useAtomValue($LibraEnableSmartBanner);

  if (enable) {
    return (
      <DynamicHead>
        <meta name="apple-itunes-app" content="app-id=1498607143" />
      </DynamicHead>
    );
  }
};

export const SmartBannerPixel = (props: ISmartBannerPixelProps) => {
  const enableSmartBanner = useAtomValue($LibraEnableSmartBanner);
  const enablePixelTracking = useAtomValue($LibraEnablePixelTracking);
  const { trafficPid } = useAtomValue($RootTraffic);
  const { schemaOption, enterPageId, enterPageType } = props;
  const [oneLink, setOneLink] = useState<string>('');

  useEffect(() => {
    const oneLink = generateOneLink({
      pid: trafficPid,
      schemaOption,
      ampExtra: {
        enter_position: enableSmartBanner ? 'smart_banner' : 'pixel_tracking',
        enter_page_id: enterPageId,
        enter_page_type: enterPageType,
      },
    });
    setOneLink(oneLink);
  }, []);

  if (enablePixelTracking) {
    return <img height={1} width={1} style={{ position: 'absolute' }} src={oneLink} />;
  } else {
    return <></>;
  }
};
